import {
	browserTracingIntegration,
	init,
	replayCanvasIntegration,
	replayIntegration,
} from "@sentry/react";

export const initSentry = () => {
	const environment = import.meta.env.VITE_CF_ENV;

	// If no environment is passed, or this is a PR preview, don't initialise Sentry
	if (!environment || environment.startsWith("pr-")) return;

	init({
		dsn: import.meta.env.VITE_SENTRY_DSN,
		environment,
		integrations: [
			browserTracingIntegration(),
			replayIntegration({
				maskAllText: false,
				blockAllMedia: false,
				unmask: [
					".error-message",
					".error-stack",
					".error-boundary",
					"pre",
					".react-error-overlay",
					'[role="alert"]',
					".ReactModal__Overlay",
					".sb-errordisplay",
					".sb-show-errordisplay",
				],
			}),
			replayCanvasIntegration({ enableManualSnapshot: true }),
		],
		tracesSampleRate: 1.0,
		replaysSessionSampleRate: 1.0,
		replaysOnErrorSampleRate: 1.0,
	});
};
